import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { SEL_API } from '../../lib/selectionShare';

export const chip = (on) => `py-2 px-1.5 rounded-lg text-[11px] border transition-colors ${on ? 'bg-[#F5A623] text-[#1A1A1A] border-[#F5A623] font-black shadow-[0_0_0_2px_rgba(245,166,35,0.35)]' : 'bg-[#111] text-gray-300 border-white/10 font-bold'}`;
const fmt = (x) => String(x).replace('.', ',');

// Outcomes of a normal market
export const Outcomes = ({ market, isOn, onPick }) => (
  <div className="grid grid-cols-3 gap-1.5 pb-3" data-testid={`market-outcomes-${market.id}`}>
    {market.esiti.map((o) => (
      <button key={o.m + o.l} type="button" onClick={() => onPick({ id: market.id, l: `${market.name}: ${o.l}`, o: o.l, s: market.cat === 'Principali' ? o.l : `${market.name} ${o.l}`, m: o.m })} className={chip(isOn(market.id, o.m))} data-testid={`market-outcome-${market.id}-${o.l}`}>{o.l}</button>
    ))}
  </div>
);

// Players of the match: lineups if out, otherwise both squads (loaded once per panel)
const usePlayers = (fixtureId) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${SEL_API}/players/${fixtureId}`, { timeout: 20000 }).then((r) => setData(r.data)).catch(() => setData({ teams: [] }));
  }, [fixtureId]);
  return data;
};

// Player market: optional choice/line, then one (or two) players
export const PlayerOutcomes = ({ market, fixtureId, isOn, onPick, lockPlayer }) => {
  const data = usePlayers(fixtureId);
  const opts = market.choices || market.lines || null;
  const [opt, setOpt] = useState(opts ? opts[0] : null);
  const [first, setFirst] = useState(null);
  const [q, setQ] = useState('');
  const f = q.trim().toLowerCase();
  const tap = (n) => {
    if (market.two && !first) { setFirst(n); return; }
    const [p, p2] = market.two ? [first, n] : [n, null];
    const o = `${market.two ? `${p} o ${p2}` : p}${opt != null ? ` (${market.choiceLabel ? market.choiceLabel(opt) : fmt(opt)})` : ''}`;
    onPick({ id: market.id, l: `${market.name}: ${o}`, o, s: `${market.name} ${o}`, m: market.tpl(p, opt, p2), dv: market.dv, player: market.two ? null : p });
    setFirst(null);
  };
  return (
    <div className="pb-3" data-testid={`market-players-${market.id}`}>
      {opts && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {opts.map((o) => <button key={o} type="button" onClick={() => setOpt(o)} className={chip(opt === o)} data-testid={`market-player-opt-${o}`}>{market.choiceLabel ? market.choiceLabel(o) : market.lines ? `Over ${fmt(o)}` : o}</button>)}
        </div>
      )}
      {lockPlayer && <p className="text-[11px] text-[#F5A623] mb-1.5" data-testid="market-panel-player-locked">In Combo i mercati giocatore usano lo stesso giocatore: {lockPlayer}</p>}
      {market.two && <p className="text-[11px] text-gray-400 mb-1.5">{first ? `Primo: ${first}. Ora scegli il secondo giocatore` : 'Scegli due giocatori'}</p>}
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca giocatore" className="w-full mb-2 bg-[#111] border border-white/10 rounded-xl px-3 py-2 text-white text-sm outline-none" data-testid="market-panel-player-search" />
      {!data && <Loader2 className="w-5 h-5 animate-spin text-[#F5A623] mx-auto my-3" />}
      {data?.source === 'squad' && <p className="text-[10px] text-gray-500 mb-2">Formazioni non ancora ufficiali: rosa completa delle due squadre</p>}
      {data && !data.teams?.some((t) => t.players?.length) && <p className="text-xs text-gray-400">Elenco giocatori non disponibile: usa "Altro".</p>}
      {data?.teams?.filter((t) => !lockPlayer || t.players.includes(lockPlayer)).map((t) => (
        <div key={t.team} className="mb-2">
          <p className="text-[10px] font-black uppercase tracking-wider text-gray-500 mb-1">{t.team}</p>
          <div className="grid grid-cols-2 gap-1.5">
            {t.players.filter((n) => (!f || n.toLowerCase().includes(f)) && (!lockPlayer || n === lockPlayer)).map((n) => (
              <button key={n} type="button" onClick={() => tap(n)} className={chip(first === n || isOn(market.id, null, n))} data-testid={`market-panel-player-${n}`}>{n}</button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
